























import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'
import { Referral } from '@/api/model/referral'
import { Order } from '@/api/model/order'
import { OrderAPI, ReferralAPI } from '@/api/backend-client'
import CommentsPanel from '@/views/Tasks/Detail/ReferralDetails/CommentsPanel.vue'
import ReferralDetailSummary from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailSummary.vue'
import ReferralDetailsTabs from '@/views/Tasks/Detail/ReferralDetails/ReferralDetailsTabs.vue'
import OrderDetailHeader from '@/views/Orders/Detail/OrderDetails/OrderDetailHeader.vue'
import OrderDetailSummary from '@/views/Orders/Detail/OrderDetails/OrderDetailSummary.vue'
import OrderDetailsTabs from '@/views/Orders/Detail/OrderDetails/OrderDetailsTabs.vue'
import OrderSidebar from '@/views/Orders/Detail/OrderSidebar.vue'

@Component({
    components: {
        OrderSidebar,
        OrderDetailsTabs,
        OrderDetailSummary,
        ReferralDetailsTabs,
        ReferralDetailSummary,
        OrderDetailHeader,
        CommentsPanel,
    },
})
export default class OrdersDetail extends Vue {
    @Prop({ required: true }) readonly orderId!: string
    order: Order = null
    loading: boolean = false

    async mounted() {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.order = await OrderAPI.get(this.orderId)
        this.loading = false
    }

    @Provide()
    async reloadOrder(): Promise<void> {
        this.loading = true
        this.order = await OrderAPI.get(this.orderId, true)
        this.loading = false
    }

    @Provide() // alias for referral components
    async reloadReferral(): Promise<void> {
        await this.reloadOrder()
    }

    @Provide()
    async saveOrder(order: Order): Promise<void> {
        this.order = await OrderAPI.update(this.orderId, order)
    }

    @Provide() // alias for referral components
    async saveReferral(referral: Referral): Promise<void> {
        this.order.referral = referral
        await ReferralAPI.update(referral.id, referral)
        await this.saveOrder(this.order)
        await this.reloadReferral()
    }

    async assignToMe(): Promise<void> {
        this.order.assignedTo = this.$currentUser
        await this.saveOrder(this.order)
        await this.reloadOrder()
    }

    get canEdit(): boolean {
        if (!this.$currentCompany || !this.order || !this.order.assignedToBranch) {
            return false
        }

        return this.$currentCompany.id === this.order.assignedToBranch.company.id
    }

    get isEditable(): boolean {
        if (!this.order || ['processed', 'closed'].includes(this.order.status)) {
            return false
        }

        return true
    }

    get isAssigned(): boolean {
        return this.order.assignedTo !== null
    }

    animateContactShow(element: HTMLDivElement, onComplete: () => void): void {
        gsap.set(element, {
            opacity: 0,
            x: '-10vw',
        })

        gsap.to(element, {
            opacity: 1,
            x: 0,
            duration: .4,
            clearProps: true,
            onComplete,
        })
    }

    animateOrderShow(element: HTMLDivElement, onComplete: () => void): void {
        gsap.set(element, {
            opacity: 0,
            x: '-4vw',
        })

        gsap.to(element, {
            delay: .4,
            x: 0,
            opacity: 1,
            duration: .4,
            clearProps: true,
            onComplete,
        })
    }
}
